import type {ICustomFormItem, CustomFormItemValue} from '../types';
import {getCustomFormBaseFieldName} from './getCustomFormBaseFieldName';

export const getCustomFormSubFieldName = (
	item: ICustomFormItem,
	value: CustomFormItemValue | string,
) =>
	`${getCustomFormBaseFieldName(item)}-${
		typeof value === 'string' ? value : value.key
	}`;
